export enum StorySize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  CAROUSEL = 'Carousel'
}

export enum ScheduleType {
  HTML5GAMES = 'html5games',
  MOMENT_GALLERIES = 'standard',
  STANDARD_READ = 'standard-read'
}
